/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ElToastrConfig } from './toastr-config';

export class ElToast {
  title: string;
  message: string;
  config: ElToastrConfig;
}

